export var EnvironmentTypes;

(function (EnvironmentTypes) {
  EnvironmentTypes["DEVELOPMENT"] = "development";
  EnvironmentTypes["STAGING"] = "staging";
  EnvironmentTypes["ONBOARDING"] = "onboarding";
  EnvironmentTypes["PRODUCTION"] = "production";
  EnvironmentTypes["LOCAL"] = "local";
})(EnvironmentTypes || (EnvironmentTypes = {}));

export var LAUNCH_DARKLY_CLIENT_SIDE_IDS = {
  local: '61a9f77ca7a8d31143a37089',
  development: '61a9f77ca7a8d31143a37089',
  staging: '61a9f4a34e7888116e020694',
  onboarding: '61a9f4afc6a5f10dd1217229',
  production: '61a9f4530be7e9119fa0857e'
};
export var COUNTRIES_ISO_3 = {
  AUT: 'AUT',
  DEU: 'DEU',
  ESP: 'ESP',
  FRA: 'FRA',
  GBR: 'GBR',
  IRL: 'IRL',
  NLD: 'NLD',
  POL: 'POL',
  FIN: 'FIN'
};
export var DEFAULT_FF_BUILDER_PARAMS = {
  isAlphaGroup: false,
  isBetaGroup: false,
  investorType: '',
  distributor: '',
  investorStatus: '',
  investorCountry: '',
  customerId: undefined
};
export var Service;

(function (Service) {
  /**
   *  Keycloak Service
   */
  Service["KEYCLOAK"] = "keycloak";
  /**
   *  Customer Authentication Service
   */

  Service["CAS"] = "cas";
  /**
   *  User Management Service
   */

  Service["UMS"] = "ums";
  /**
   * Strong Customer Authentication Service
   */

  Service["SCAS"] = "scas";
  /**
   * Customer Postbox Service
   */

  Service["CPS"] = "cps";
  /**
   *  Integration Service
   */

  Service["IS"] = "is";
  /**
   *  Legacy Online Banking System
   */

  Service["OBS"] = "obs";
  /**
   *  Transaction Account Management Service
   */

  Service["TAMS"] = "tams";
  /**
   *  WJ Integration Service
   */

  Service["WJIS"] = "wjis";
  /**
   *  Customer Payment Method Service
   */

  Service["CPMS"] = "cpms";
  /**
   *  Zendesk
   */

  Service["Zendesk"] = "zendesk";
  /**
   * Document Depot Service
   */

  Service["DDS"] = "dds";
  /**
   *  Customer Taxation Service
   */

  Service["CTS"] = "cts";
  /**
   *  KYC Connector IDnow Service
   */

  Service["KCI"] = "kci";
  /**
   *  KYC Status Service
   */

  Service["KSS"] = "kss";
  /**
   *  KYC Connector Postident Service
   */

  Service["KCPS"] = "kcps";
  /**
   *  PSD Connector
   */

  Service["PSDC"] = "psdc";
  /**
   *  Customer Transaction Management API
   */

  Service["CTMS"] = "ctms";
  /**
   *  Pension service
   */

  Service["PENSION"] = "pension";
})(Service || (Service = {}));

export var HttpMethod;

(function (HttpMethod) {
  HttpMethod["GET"] = "get";
  HttpMethod["POST"] = "post";
  HttpMethod["PUT"] = "put";
  HttpMethod["PATCH"] = "patch";
  HttpMethod["DELETE"] = "delete";
})(HttpMethod || (HttpMethod = {}));

export var ENVIRONMENT_DOMAINS = {
  local: 'dev-',
  development: 'dev-',
  staging: 'staging-',
  onboarding: 'onboarding-',
  production: ''
};
export var DOMAIN_LOCALE = {
  'weltsparen.de': 'de-DE',
  'weltsparen.at': 'de-AT',
  'raisin.co.uk': 'en-GB',
  'raisin.ie': 'en-IE',
  'raisin.es': 'es-ES',
  'raisin.fr': 'fr-FR',
  'raisin.nl': 'nl-NL',
  'raisin.com/pl-pl': 'pl-PL',
  'raisin.com/fi-fi': 'fi-FI',
  'raisin.com/fr-fr': 'fr-FR'
};
export var FORMATTED_LOCALE = {
  en: 'en',
  'en-us': 'en-US',
  'de-de': 'de-DE',
  'en-gb': 'en-GB',
  'en-ie': 'en-IE',
  'es-es': 'es-ES',
  'nl-nl': 'nl-NL',
  'de-at': 'de-AT',
  'fr-fr': 'fr-FR',
  'pl-pl': 'pl-PL',
  'fi-fi': 'fi-FI'
};
export var REGISTRATION_BASE_PATH = {
  en: '/register/',
  'en-US': '/register/',
  'de-DE': '/register/',
  'en-GB': '/register/',
  'en-IE': '/register/',
  'es-ES': '/register/',
  'nl-NL': '/register/',
  'de-AT': '/register/',
  'fr-FR': '/fr-fr/register/',
  'pl-PL': '/pl-pl/register/',
  'fi-FI': '/fi-fi/register/'
};
export var UNIFIED_DOMAIN_LOCALES = ['pl-pl', 'fi-fi', 'en', 'en-us'];
export var SITE_URL = {
  en: 'https://www.raisin.com/en',
  'en-US': 'https://www.raisin.com/en-US',
  'de-DE': 'https://www.weltsparen.de',
  'en-GB': 'https://www.raisin.co.uk',
  'en-IE': 'https://www.raisin.ie',
  'es-ES': 'https://www.raisin.es',
  'nl-NL': 'https://www.raisin.nl',
  'de-AT': 'https://www.weltsparen.at',
  'fr-FR': 'https://www.raisin.fr',
  'pl-PL': 'https://www.raisin.com/pl-pl',
  'fi-FI': 'https://www.raisin.com/fi-fi'
};
export var WJIS_BASE_PATH = {
  en: 'raisin.com/wjis/com/v1',
  'en-US': 'raisin.com/wjis/com/v1',
  'de-DE': 'weltsparen.de/dp/public/v1',
  'en-GB': 'raisin.co.uk/dp/public/v1',
  'en-IE': 'raisin.ie/dp/public/v1',
  'es-ES': 'raisin.es/dp/public/v1',
  'nl-NL': 'raisin.nl/dp/public/v1',
  'de-AT': 'weltsparen.at/dp/public/v1',
  'fr-FR': 'raisin.fr/dp/public/v1',
  'pl-PL': 'raisin.com/wjis/pol/v1',
  'fi-FI': 'raisin.com/wjis/fin/v1'
};
export var WJIS_BASE_PATH_LOCALE_SUFFIX = {
  en: 'com',
  'en-US': 'com',
  'de-DE': '',
  'en-GB': '',
  'en-IE': '',
  'es-ES': '',
  'nl-NL': '',
  'de-AT': '',
  'fr-FR': 'fra',
  'pl-PL': 'pol',
  'fi-FI': 'fin'
};
export var DOMAIN_LOCALE_SUFFIX = {
  en: '',
  'en-US': '',
  'de-DE': '',
  'en-GB': '',
  'en-IE': '',
  'es-ES': '',
  'nl-NL': '',
  'de-AT': '',
  'fr-FR': 'fr-fr/',
  'pl-PL': 'pl-pl/',
  'fi-FI': 'fi-fi/'
};
export var BASE_PATH = {
  en: 'en',
  'en-US': 'en',
  'de-DE': '',
  'en-GB': '',
  'en-IE': '',
  'es-ES': '',
  'nl-NL': '',
  'de-AT': '',
  'fr-FR': 'fr-fr',
  'pl-PL': 'pl-pl',
  'fi-FI': 'fi-fi'
};
export var DOMAIN_FOR_LOCALE = {
  en: 'raisin.com/en',
  'en-US': 'raisin.com/en',
  'de-DE': 'weltsparen.de',
  'en-GB': 'raisin.co.uk',
  'en-IE': 'raisin.ie',
  'es-ES': 'raisin.es',
  'nl-NL': 'raisin.nl',
  'de-AT': 'weltsparen.at',
  'fr-FR': 'raisin.fr',
  'pl-PL': 'raisin.com/pl-pl',
  'fi-FI': 'raisin.com/fi-pl'
};
export var COM_USERCENTRIC_ID = 'jParYzZAU';
export var LOCALE_USERCENTRIC_ID = {
  'de-DE': 'HHbqSIBMT',
  'de-AT': 'w604LrpCd',
  'en-GB': 'RzEqJUZ30',
  'fr-FR': 'Y_54cP7tT',
  'es-ES': '0wvnck-sc',
  'nl-NL': 'v7-AjGZoM',
  'en-IE': 'cww6iKo0E'
};
export var ZENDESK_SUBDOMAINS = {
  'de-DE': 'weltsparen-de',
  'de-AT': 'weltsparen-at',
  'en-GB': 'raisinuk',
  'en-US': 'raisin-eu',
  'fr-FR': 'raisin-fr',
  'nl-NL': 'raisin-nl',
  'en-IE': 'raisin-ie',
  'es-ES': 'raisin-es',
  'pl-PL': 'raisin-pl',
  'fi-FI': 'raisinfi',
  en: 'raisin-eu'
};
export var DEFAULT_LOCALE = 'de-DE';
export var API_GATEWAY_ENDPOINTS;

(function (API_GATEWAY_ENDPOINTS) {
  API_GATEWAY_ENDPOINTS["LOCAL"] = "http://localhost:8080";
  API_GATEWAY_ENDPOINTS["DEU_DEVELOPMENT"] = "https://api2.dev-weltsparen.de";
  API_GATEWAY_ENDPOINTS["DEU_ONBOARDING"] = "https://api2.onboarding-weltsparen.de";
  API_GATEWAY_ENDPOINTS["DEU_PRODUCTION"] = "https://api2.weltsparen.de";
  API_GATEWAY_ENDPOINTS["DEU_STAGING"] = "https://api2.staging-weltsparen.de";
  API_GATEWAY_ENDPOINTS["GBR_DEVELOPMENT"] = "https://api2.dev-raisin.co.uk";
  API_GATEWAY_ENDPOINTS["GBR_ONBOARDING"] = "https://api2.onboarding-raisin.co.uk";
  API_GATEWAY_ENDPOINTS["GBR_PRODUCTION"] = "https://api2.raisin.co.uk";
  API_GATEWAY_ENDPOINTS["GBR_STAGING"] = "https://api2.staging-raisin.co.uk";
})(API_GATEWAY_ENDPOINTS || (API_GATEWAY_ENDPOINTS = {}));

export var MICROSERVICES = {
  wjis: {
    gbr: {
      local: 'https://api2.dev-raisin.com/wjis',
      development: 'https://api2.dev-raisin.com/wjis',
      staging: 'https://api2.staging-raisin.com/wjis',
      onboarding: 'https://api2.onboarding-raisin.com/wjis',
      production: 'https://api2.raisin.com/wjis'
    },
    deu: {
      local: 'https://api2.dev-raisin.com/wjis',
      development: 'https://api2.dev-raisin.com/wjis',
      staging: 'https://api2.staging-raisin.com/wjis',
      onboarding: 'https://api2.onboarding-raisin.com/wjis',
      production: 'https://api2.raisin.com/wjis'
    }
  },
  ums: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/ums/v1',
      development: 'https://api2.dev-raisin.co.uk/ums/v1',
      staging: 'https://api2.staging-raisin.co.uk/ums/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/ums/v1',
      production: 'https://api2.raisin.co.uk/ums/v1'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/ums/v1',
      development: 'https://api2.dev-weltsparen.de/ums/v1',
      staging: 'https://api2.staging-weltsparen.de/ums/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/ums/v1',
      production: 'https://api2.weltsparen.de/ums/v1'
    }
  },
  cas: {
    mock: 'http://localhost:9000/cas/public/v1',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/cas/public/v1',
      development: 'https://api2.dev-raisin.co.uk/cas/public/v1',
      staging: 'https://api2.staging-raisin.co.uk/cas/public/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/cas/public/v1',
      production: 'https://api2.raisin.co.uk/cas/public/v1'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/cas/public/v1',
      development: 'https://api2.dev-weltsparen.de/cas/public/v1',
      staging: 'https://api2.staging-weltsparen.de/cas/public/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/cas/public/v1',
      production: 'https://api2.weltsparen.de/cas/public/v1'
    }
  },
  cts: {
    requestTimeout: 20000,
    mock: 'http://localhost:8080',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/cts/public',
      development: 'https://api2.dev-raisin.co.uk/cts/public',
      staging: 'https://api2.staging-raisin.co.uk/cts/public',
      onboarding: 'https://api2.onboarding-raisin.co.uk/cts/public',
      production: 'https://api2.raisin.co.uk/cts/public'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/cts/public',
      development: 'https://api2.dev-weltsparen.de/cts/public',
      staging: 'https://api2.staging-weltsparen.de/cts/public',
      onboarding: 'https://api2.onboarding-weltsparen.de/cts/public',
      production: 'https://api2.weltsparen.de/cts/public'
    }
  },
  scas: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/scas/api/v2',
      development: 'https://api2.dev-raisin.co.uk/scas/api/v2',
      staging: 'https://api2.staging-raisin.co.uk/scas/api/v2',
      onboarding: 'https://api2.onboarding-raisin.co.uk/scas/api/v2',
      production: 'https://api2.raisin.co.uk/scas/api/v2'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/scas/api/v2',
      development: 'https://api2.dev-weltsparen.de/scas/api/v2',
      staging: 'https://api2.staging-weltsparen.de/scas/api/v2',
      onboarding: 'https://api2.onboarding-weltsparen.de/scas/api/v2',
      production: 'https://api2.weltsparen.de/scas/api/v2'
    }
  },
  cps: {
    mock: 'http://localhost:9000/cps/api/v1',
    gbr: {
      local: 'https://api.dev-raisin.co.uk/cps/api/v1',
      development: 'https://api.dev-raisin.co.uk/cps/api/v1',
      staging: 'https://api.staging-raisin.co.uk/cps/api/v1',
      onboarding: 'https://api.onboarding-raisin.co.uk/cps/api/v1',
      production: 'https://api.raisin.co.uk/cps/api/v1'
    },
    deu: {
      local: 'https://api.dev-weltsparen.de/cps/api/v1',
      development: 'https://api.dev-weltsparen.de/cps/api/v1',
      staging: 'https://api.staging-weltsparen.de/cps/api/v1',
      onboarding: 'https://api.onboarding-weltsparen.de/cps/api/v1',
      production: 'https://api.weltsparen.de/cps/api/v1'
    }
  },
  tams: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/tams/v1',
      development: 'https://api2.dev-raisin.co.uk/tams/v1',
      staging: 'https://api2.staging-raisin.co.uk/tams/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/tams/v1',
      production: 'https://api2.raisin.co.uk/tams/v1'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/tams/v1',
      development: 'https://api2.dev-weltsparen.de/tams/v1',
      staging: 'https://api2.staging-weltsparen.de/tams/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/tams/v1',
      production: 'https://api2.weltsparen.de/tams/v1'
    }
  },
  keycloak: {
    gbr: {
      local: 'https://auth-gbr-development.raisin-dev.network/auth/realms/global',
      development: 'https://auth-gbr-development.raisin-dev.network/auth/realms/global',
      staging: 'https://auth.staging-raisin.co.uk/auth/realms/global',
      onboarding: 'https://auth.onboarding-raisin.co.uk/auth/realms/global',
      production: 'https://auth.raisin.co.uk/auth/realms/global'
    },
    deu: {
      local: 'https://auth-deu-development.raisin-dev.network/auth/realms/global',
      development: 'https://auth-deu-development.raisin-dev.network/auth/realms/global',
      staging: 'https://auth.staging-weltsparen.de/auth/realms/global',
      onboarding: 'https://auth.onboarding-weltsparen.de/auth/realms/global',
      production: 'https://auth.weltsparen.de/auth/realms/global'
    }
  },
  cpms: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/cpms/public/v1',
      development: 'https://api2.dev-raisin.co.uk/cpms/public/v1',
      staging: 'https://api2.staging-raisin.co.uk/cpms/public/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/cpms/public/v1',
      production: 'https://api2.raisin.co.uk/cpms/public/v1'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/cpms/public/v1',
      development: 'https://api2.dev-weltsparen.de/cpms/public/v1',
      staging: 'https://api2.staging-weltsparen.de/cpms/public/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/cpms/public/v1',
      production: 'https://api2.weltsparen.de/cpms/public/v1'
    }
  },
  dds: {
    mock: 'http://localhost:9000/dds/api/v2',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/dds/api/v2',
      development: 'https://api2.dev-raisin.co.uk/dds/api/v2',
      staging: 'https://api2.staging-raisin.co.uk/dds/api/v2',
      onboarding: 'https://api2.onboarding-raisin.co.uk/dds/api/v2',
      production: 'https://api2.raisin.co.uk/dds/api/v2'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/dds/api/v2',
      development: 'https://api2.dev-weltsparen.de/dds/api/v2',
      staging: 'https://api2.staging-weltsparen.de/dds/api/v2',
      onboarding: 'https://api2.onboarding-weltsparen.de/dds/api/v2',
      production: 'https://api2.weltsparen.de/dds/api/v2'
    }
  },
  kci: {
    mock: 'http://localhost:9000/kci/api/v1',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/kci/api/v1',
      development: 'https://api2.dev-raisin.co.uk/kci/api/v1',
      staging: 'https://api2.staging-raisin.co.uk/kci/api/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/kci/api/v1',
      production: 'https://api2.raisin.co.uk/kci/api/v1'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/kci/api/v1',
      development: 'https://api2.dev-weltsparen.de/kci/api/v1',
      staging: 'https://api2.staging-weltsparen.de/kci/api/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/kci/api/v1',
      production: 'https://api2.weltsparen.de/kci/api/v1'
    }
  },
  kss: {
    mock: 'http://localhost:9000/kss/api/v1',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/kss/api/v1',
      development: 'https://api2.dev-raisin.co.uk/kss/api/v1',
      staging: 'https://api2.staging-raisin.co.uk/kss/api/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/kss/api/v1',
      production: 'https://api2.raisin.co.uk/kss/api/v1'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/kss/api/v1',
      development: 'https://api2.dev-weltsparen.de/kss/api/v1',
      staging: 'https://api2.staging-weltsparen.de/kss/api/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/kss/api/v1',
      production: 'https://api2.weltsparen.de/kss/api/v1'
    }
  },
  kcps: {
    mock: 'http://localhost:9000/kcps/api/v1',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/kcps/api/v1',
      development: 'https://api2.dev-raisin.co.uk/kcps/api/v1',
      staging: 'https://api2.staging-raisin.co.uk/kcps/api/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/kcps/api/v1',
      production: 'https://api2.raisin.co.uk/kcps/api/v1'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/kcps/api/v1',
      development: 'https://api2.dev-weltsparen.de/kcps/api/v1',
      staging: 'https://api2.staging-weltsparen.de/kcps/api/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/kcps/api/v1',
      production: 'https://api2.weltsparen.de/kcps/api/v1'
    }
  },
  psdc: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/psdc/v1/public',
      development: 'https://api2.dev-raisin.co.uk/psdc/v1/public',
      staging: 'https://api2.staging-raisin.co.uk/psdc/v1/public',
      onboarding: 'https://api2.onboarding-raisin.co.uk/psdc/v1/public',
      production: 'https://api2.raisin.co.uk/psdc/v1/public'
    }
  },
  ctms: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/ctms/v1/public',
      development: 'https://api2.dev-raisin.co.uk/ctms/v1/public',
      staging: 'https://api2.staging-raisin.co.uk/ctms/v1/public',
      onboarding: 'https://api2.onboarding-raisin.co.uk/ctms/v1/public',
      production: 'https://api2.raisin.co.uk/ctms/v1/public'
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/ctms/v1/public',
      development: 'https://api2.dev-weltsparen.de/ctms/v1/public',
      staging: 'https://api2.staging-weltsparen.de/ctms/v1/public',
      onboarding: 'https://api2.onboarding-weltsparen.de/ctms/v1/public',
      production: 'https://api2.weltsparen.de/ctms/v1/public'
    }
  }
};
export var Environment;

(function (Environment) {
  Environment["Local"] = "local";
  Environment["Development"] = "development";
  Environment["Staging"] = "staging";
  Environment["Onboarding"] = "onboarding";
  Environment["Production"] = "production";
})(Environment || (Environment = {}));

export var HttpResponseMockType;

(function (HttpResponseMockType) {
  HttpResponseMockType["RESOLVE"] = "resolve";
  HttpResponseMockType["REJECT"] = "reject";
})(HttpResponseMockType || (HttpResponseMockType = {}));

export var MAIL_CONSENTS_MOCK = {
  id: {
    bac_number: 'BAC_111_181_987_988'
  },
  consents: [{
    id: 'pensions',
    legitimate_interest: false,
    description: 'Alles rund um Riester, Rürup, bAV',
    name: 'Altersvorsorge',
    valid: false
  }, {
    id: 'savings',
    legitimate_interest: false,
    description: 'Neuigkeiten rund um Tages- und Festgeldangebote\t',
    name: 'Sparprodukte',
    valid: false
  }, {
    id: 'investments',
    legitimate_interest: false,
    description: 'Wissenswertes über Anlageportfolios, die Kapitalmärkte sowie Webinare und Bonusaktionen\t',
    name: 'Investmentprodukte',
    valid: false
  }, {
    id: 'beta_program',
    legitimate_interest: false,
    description: 'Beta-Programm',
    name: 'Beta Programm',
    valid: false
  }, {
    id: 'cs',
    legitimate_interest: true,
    description: 'Aktuelles zu Ihrem WeltSpar-Konto',
    name: 'Wichtige Informationen',
    valid: true
  }, {
    id: 'legal',
    legitimate_interest: true,
    description: 'Nicht abwählbare, verpflichtende Produkt- und Serviceinformationen bspw. Bestätigungen von Produkteröffnungen oder Stornierungen',
    name: 'Rechtliches',
    valid: true
  }]
};
export var CustomerStatus;

(function (CustomerStatus) {
  CustomerStatus["Registered"] = "REGISTERED";
  CustomerStatus["Identified"] = "IDENTIFIED";
  CustomerStatus["PendingAcceptance"] = "PENDING_SERVICING_BANK_ACCEPTANCE";
  CustomerStatus["Active"] = "ACTIVE";
  CustomerStatus["Rejected"] = "REJECTED";
  CustomerStatus["DeletionInitiated"] = "DELETION_INITIATED";
  CustomerStatus["Deleted"] = "DELETED";
  CustomerStatus["TerminationRequested"] = "TERMINATION_REQUESTED";
  CustomerStatus["TerminationInitiated"] = "TERMINATION_INITIATED";
  CustomerStatus["Terminated"] = "TERMINATED";
})(CustomerStatus || (CustomerStatus = {}));

export var CustomerType;

(function (CustomerType) {
  CustomerType["JOINT"] = "JOINT";
  CustomerType["PERSONAL"] = "PERSONAL";
  CustomerType["BUSINESS"] = "BUSINESS";
})(CustomerType || (CustomerType = {}));

export var PersonRole;

(function (PersonRole) {
  PersonRole["AccountHolder"] = "ACCOUNT_HOLDER";
  PersonRole["UltimateOwner"] = "ULTIMATE_BENEFICIAL_OWNER";
  PersonRole["AuthorizedPerson"] = "AUTHORIZED_PERSON";
  PersonRole["LegalRepresentative"] = "LEGAL_REPRESENTATIVE";
  PersonRole["TaxPartner"] = "TAX_PARTNER";
})(PersonRole || (PersonRole = {}));

export var PersonRoleStatus;

(function (PersonRoleStatus) {
  PersonRoleStatus["Requested"] = "REQUESTED";
  PersonRoleStatus["Active"] = "ACTIVE";
  PersonRoleStatus["Disabled"] = "DISABLED";
})(PersonRoleStatus || (PersonRoleStatus = {}));

export var CUSTOMER_MOCK = {
  id: 'BAC_111_139_021_118',
  legacyId: {
    partnerNo: '41134'
  },
  status: CustomerStatus.Active,
  type: 'PERSONAL',
  distributorId: 'Raisin',
  distributionChannelId: 'raisin_direct_retail_deu',
  registrationDate: '2021-12-07',
  company: null,
  persons: [],
  address: {
    street: 'Friesenweg Ranch',
    streetNumber: '61b',
    additionalInformation: null,
    city: 'Holinskistadt',
    flatNumber: null,
    postalCode: '22264',
    countryCode: 'DEU'
  },
  deliveryAddress: null,
  _embedded: {
    persons: [{
      id: 'PER_100_000_001_815',
      personId: '28910013',
      firstName: 'Marie',
      lastName: 'Schwalm',
      birthDate: '1943-12-02',
      username: '2041134006',
      personalDetails: {
        academicTitleCode: 'academic_title_dr_med',
        courtesyTitleCode: 'courtesy_title_mr',
        firstName: 'Marie',
        lastName: 'Schwalm',
        birthName: null,
        birthDate: '1943-12-02',
        birthPlace: 'Haverneyfeld',
        birthCountryCode: 'DEU',
        nationalityPrimary: 'DEU',
        nationalitySecondary: null,
        gender: 'gender_male',
        maritalStatus: 'marital_status_widowed',
        profession: 'profession_employee',
        industry: null
      },
      address: {
        street: 'Friesenweg Ranch',
        streetNumber: '61b',
        additionalInformation: null,
        city: 'Holinskistadt',
        flatNumber: null,
        postalCode: '22264',
        countryCode: 'DEU'
      },
      contactDetails: {
        email: 'tara.palmer-1638887711556@test.com',
        phoneNumber: '+49151175497739'
      },
      taxDetails: [{
        taxIdentificationNumber: '44601235785',
        countryCode: 'DEU',
        precedence: 0
      }],
      additionalFinancialInformation: {
        pep: {
          additionalInfo: 'PEP - Additional Information',
          status: 'EXPOSED_DIRECTLY'
        },
        sourceOfFunds: {
          originOfFunds: 'professional_income',
          annualIncome: {
            displayedText: 'EUR 20,000 to EUR 40,000',
            code: 'income_range.2'
          }
        }
      },
      roles: [{
        id: '1',
        name: 'ACCOUNT_HOLDER',
        status: 'ACTIVE'
      }]
    }],
    referenceAccounts: [{
      accountId: '28910026',
      accountHolder: 'Marie Schwalm',
      bankName: 'Landesbank Berlin - Berliner Sparkasse',
      bic: 'BELADEBEXXX',
      iban: 'DE42100500005365875853',
      accountNumber: '5365875853',
      branchCode: null,
      ccy: 'EUR'
    }],
    dataValidity: null
  }
};
export var LD_CLIENT_CACHE_KEY = 'launchDarklyClient';
export var CLIENT_CACHE_KEY = 'raisinFrontendClient';